var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useStateWithMutators } from '@rad/hooks';
import { SITE_IS_AUTO, TEXT } from '../../../utility/constants';
import { formatDate, formatDollars, formatInvoiceNumber } from '../../../utility/formatters';
import { calculateItems } from '../../../utility/calculations';
import { postObjectJson } from '../../../utility/request';
import { EstimateSendForm } from './estimate-send';
import CInput from '../input';
import CSwitch from '../switch';
import CModal from '../modal';
import CErrors from '../errors';
export default (props) => {
    var _a, _b;
    const sendRef = React.useRef(null);
    const [sendDisabled, setSendDisabled] = React.useState(true);
    const [state, mutators] = useStateWithMutators({
        'which': 'internal',
        'convert': true,
        'odometerin': null,
        'approved': [],
        'errors': [],
    });
    React.useEffect(() => {
        if (!props.invoice) {
            return;
        }
        mutators.which('internal');
        mutators.convert(true);
        mutators.odometerin(null);
        mutators.approved([]);
        mutators.errors([]);
    }, [(_a = props.invoice) === null || _a === void 0 ? void 0 : _a.id]);
    const toggleApproved = (jobId, value) => {
        if (value) {
            if (!state.approved.includes(jobId)) {
                mutators.approved(state.approved.concat([jobId]));
            }
            return;
        }
        mutators.approved(state.approved.filter((x) => x !== jobId));
    };
    const submit = (complete) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            if (!props.invoice) {
                return;
            }
            mutators.errors([]);
            switch (state.which) {
                case 'internal':
                    yield postObjectJson(`/merchants/${props.invoice.merchant.id}/invoices/${props.invoice.id}/approve-jobs`, {
                        'job_ids': state.approved,
                        'convert': state.convert,
                        'odometerin': state.odometerin,
                    }, {
                        'error': (res) => __awaiter(void 0, void 0, void 0, function* () { return mutators.errors(yield res.json()); }),
                        'success': () => __awaiter(void 0, void 0, void 0, function* () { return props.onClose(true); }),
                    });
                    break;
                case 'external':
                    if (yield ((_a = sendRef.current) === null || _a === void 0 ? void 0 : _a.submit())) {
                        props.onClose(true);
                    }
                    break;
                default:
                    props.onClose(true);
                    break;
            }
        }
        catch (_b) {
            mutators.errors([{ 'field': '_', 'message': 'An error occured' }]);
        }
        finally {
            complete();
        }
    });
    const needsOdometerIn = SITE_IS_AUTO && state.which === 'internal' && state.convert && !!props.invoice && props.invoice.odometerin === null;
    return _jsx(_Fragment, { children: _jsxs(CModal, { visible: !!props.invoice, title: `Estimate Approval - ${formatInvoiceNumber(props.invoice)}`, onClose: () => props.onClose(false), onSubmit: submit, disabled: (state.which === 'internal' && !state.approved.length) || (state.which === 'external' && sendDisabled) || (needsOdometerIn && state.odometerin === null), children: [_jsxs("ul", { className: "nav nav-tabs", children: [_jsx("li", { className: "nav-item", children: _jsx("a", { href: "#", onClick: (e) => { e.preventDefault(); mutators.which('internal'); }, className: `nav-link ${state.which === 'internal' ? 'active bg-light' : ''}`, children: "In-Person" }) }), _jsx("li", { className: "nav-item", children: _jsx("a", { href: "#", onClick: (e) => { e.preventDefault(); mutators.which('external'); }, className: `nav-link ${state.which === 'external' ? 'active bg-light' : ''}`, children: "Send Link" }) })] }), _jsxs("div", { className: "bg-light border border-top-0 rounded-bottom p-2", children: [state.which === 'internal' && _jsxs(_Fragment, { children: [_jsx(CErrors, { errors: state.errors }), _jsxs("table", { className: "table table-sm table-striped", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Job" }), _jsx("th", { children: "Card" }), _jsx("th", { children: "Cash" }), _jsx("th", { className: "w-1", children: "Approved" })] }) }), _jsx("tbody", { children: (((_b = props.invoice) === null || _b === void 0 ? void 0 : _b.jobs) || []).map((x) => {
                                                var _a;
                                                const itemsByJob = ((_a = props.invoice) === null || _a === void 0 ? void 0 : _a.items.filter((y) => y.job_id === x.id)) || [];
                                                return _jsxs("tr", { children: [_jsxs("td", { children: [x.title_display, x.optional ? _jsx("span", { className: "text-danger", children: "*" }) : null] }), _jsx("td", { children: formatDollars(calculateItems('card', 'total', 'all', { 'items': itemsByJob, 'merchant': props.invoice.merchant })) }), _jsx("td", { children: formatDollars(calculateItems('cash', 'total', 'all', { 'items': itemsByJob, 'merchant': props.invoice.merchant })) }), !!x.client_approved
                                                            ? _jsx("td", { children: formatDate(x.client_approved) })
                                                            : _jsx("td", { children: _jsx(CSwitch, { value: state.approved.includes(x.id), onChange: (v) => toggleApproved(x.id, v), slotChecked: "Approved", slotUnchecked: "Declined" }) })] }, x.id);
                                            }) })] }), _jsx(CSwitch, { value: state.convert, onChange: mutators.convert, slotChecked: `And Convert to ${TEXT.ORDER_TITLE}`, slotUnchecked: "And Keep as Estimate" }), needsOdometerIn && _jsx("div", { className: "mt-2", children: _jsx(CInput, { type: "number", value: state.odometerin, onChange: mutators.odometerin, required: true, children: "Odometer In" }) })] }), state.which === 'external' && _jsx(_Fragment, { children: _jsx(EstimateSendForm, { ref: sendRef, invoice: props.invoice, sendKind: "initial", onDisabledChange: setSendDisabled }) })] })] }) });
};
